import axios from "axios";

const baseURL =
  import.meta.env.VITE_AUTH_API_URL ||
  "https://security-api.azurewebsites.net/api/v1";

export const axiosAuth = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});
